import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

const iconMap = {
  home: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  forum: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  category: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="9" y1="3" x2="9" y2="21" />
      <line x1="3" y1="9" x2="21" y2="9" />
    </svg>
  ),
  character: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
};

const Breadcrumb = ({ items, variant = 'default' }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav
      className={`${styles.breadcrumb} ${variant === 'compact' ? styles.compact : ''}`}
      aria-label="Fil d'Ariane"
    >
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const icon = item.icon ? iconMap[item.icon] : null;

          return (
            <li key={index} className={styles.item}>
              {item.url && !isLast ? (
                <Link to={item.url} className={styles.link}>
                  {icon && <span className={styles.icon}>{icon}</span>}
                  <span className={styles.text}>{item.name}</span>
                </Link>
              ) : (
                <span className={styles.current}>
                  {icon && <span className={styles.icon}>{icon}</span>}
                  <span className={styles.text}>{item.name}</span>
                </span>
              )}
              {!isLast && (
                <span className={styles.separator}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
